module.exports = {
    STANDARD : "standard", // Standard is account
    CLASS : "class",
};